(() => {
	"use strict";

	const modules_flsModules = {};
	function isWebp() {
		function testWebP(callback) {
			let webP = new Image();
			webP.onload = webP.onerror = function () {
				callback(webP.height == 2);
			};
			webP.src = "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
		}
		testWebP(function (support) {
			let className = support === true ? "webp" : "no-webp";
			document.documentElement.classList.add(className);
		});
	}
	function functions_getHash() {
		if (location.hash) return location.hash.replace("#", "");
	}
	function setHash(hash) {
		hash = hash ? `#${hash}` : window.location.href.split("#")[0];
		history.pushState("", "", hash);
	}
	let _slideUp = (target, duration = 500, showmore = 0) => {
		if (!target.classList.contains("_slide")) {
			target.classList.add("_slide");
			target.style.transitionProperty = "height, margin, padding";
			target.style.transitionDuration = duration + "ms";
			target.style.height = `${target.offsetHeight}px`;
			target.offsetHeight;
			target.style.overflow = "hidden";
			target.style.height = showmore ? `${showmore}px` : `0px`;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			window.setTimeout(() => {
				target.hidden = !showmore ? true : false;
				!showmore ? target.style.removeProperty("height") : null;
				target.style.removeProperty("padding-top");
				target.style.removeProperty("padding-bottom");
				target.style.removeProperty("margin-top");
				target.style.removeProperty("margin-bottom");
				!showmore ? target.style.removeProperty("overflow") : null;
				target.style.removeProperty("transition-duration");
				target.style.removeProperty("transition-property");
				target.classList.remove("_slide");
				document.dispatchEvent(
					new CustomEvent("slideUpDone", {
						detail: {
							target,
						},
					})
				);
			}, duration);
		}
	};
	let _slideDown = (target, duration = 500, showmore = 0) => {
		if (!target.classList.contains("_slide")) {
			target.classList.add("_slide");
			target.hidden = target.hidden ? false : null;
			showmore ? target.style.removeProperty("height") : null;
			let height = target.offsetHeight;
			target.style.overflow = "hidden";
			target.style.height = showmore ? `${showmore}px` : `0px`;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			target.offsetHeight;
			target.style.transitionProperty = "height, margin, padding";
			target.style.transitionDuration = duration + "ms";
			target.style.height = height + "px";
			target.style.removeProperty("padding-top");
			target.style.removeProperty("padding-bottom");
			target.style.removeProperty("margin-top");
			target.style.removeProperty("margin-bottom");
			window.setTimeout(() => {
				target.style.removeProperty("height");
				target.style.removeProperty("overflow");
				target.style.removeProperty("transition-duration");
				target.style.removeProperty("transition-property");
				target.classList.remove("_slide");
				document.dispatchEvent(
					new CustomEvent("slideDownDone", {
						detail: {
							target,
						},
					})
				);
			}, duration);
		}
	};
	let bodyLockStatus = true;
	let bodyUnlock = (delay = 500) => {
		let body = document.querySelector("body");
		if (bodyLockStatus) {
			let lock_padding = document.querySelectorAll("[data-lp]");
			setTimeout(() => {
				for (let index = 0; index < lock_padding.length; index++) {
					const el = lock_padding[index];
					el.style.paddingRight = "0px";
				}
				body.style.paddingRight = "0px";
				document.documentElement.classList.remove("lock");
			}, delay);
			bodyLockStatus = false;
			setTimeout(function () {
				bodyLockStatus = true;
			}, delay);
		}
	};
	function tabs() {
		const tabs = document.querySelectorAll("[data-tabs]");
		let tabsActiveHash = [];
		if (tabs.length > 0) {
			const hash = functions_getHash();
			if (hash && hash.startsWith("tab-")) tabsActiveHash = hash.replace("tab-", "").split("-");
			tabs.forEach((tabsBlock, index) => {
				tabsBlock.classList.add("_tab-init");
				tabsBlock.setAttribute("data-tabs-index", index);
				tabsBlock.addEventListener("click", setTabsAction);
				initTabs(tabsBlock);
			});
			let mdQueriesArray = dataMediaQueries(tabs, "tabs");
			if (mdQueriesArray && mdQueriesArray.length)
				mdQueriesArray.forEach((mdQueriesItem) => {
					mdQueriesItem.matchMedia.addEventListener("change", function () {
						setTitlePosition(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
					});
					setTitlePosition(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
				});
		}
		function setTitlePosition(tabsMediaArray, matchMedia) {
			tabsMediaArray.forEach((tabsMediaItem) => {
				tabsMediaItem = tabsMediaItem.item;
				let tabsTitles = tabsMediaItem.querySelector("[data-tabs-titles]");
				let tabsTitleItems = tabsMediaItem.querySelectorAll("[data-tabs-title]");
				let tabsContent = tabsMediaItem.querySelector("[data-tabs-body]");
				let tabsContentItems = tabsMediaItem.querySelectorAll("[data-tabs-item]");
				tabsTitleItems = Array.from(tabsTitleItems).filter((item) => item.closest("[data-tabs]") === tabsMediaItem);
				tabsContentItems = Array.from(tabsContentItems).filter((item) => item.closest("[data-tabs]") === tabsMediaItem);
				tabsContentItems.forEach((tabsContentItem, index) => {
					if (matchMedia.matches) {
						tabsContent.append(tabsTitleItems[index]);
						tabsContent.append(tabsContentItem);
						tabsMediaItem.classList.add("_tab-spoller");
					} else {
						tabsTitles.append(tabsTitleItems[index]);
						tabsMediaItem.classList.remove("_tab-spoller");
					}
				});
			});
		}
		function initTabs(tabsBlock) {
			let tabsTitles = tabsBlock.querySelectorAll("[data-tabs-titles]>*");
			let tabsContent = tabsBlock.querySelectorAll("[data-tabs-body]>*");
			const tabsBlockIndex = tabsBlock.dataset.tabsIndex;
			const tabsActiveHashBlock = tabsActiveHash[0] == tabsBlockIndex;
			if (tabsActiveHashBlock) {
				const tabsActiveTitle = tabsBlock.querySelector("[data-tabs-titles]>._tab-active");
				tabsActiveTitle ? tabsActiveTitle.classList.remove("_tab-active") : null;
			}
			if (tabsContent.length)
				tabsContent.forEach((tabsContentItem, index) => {
					tabsTitles[index].setAttribute("data-tabs-title", "");
					tabsContentItem.setAttribute("data-tabs-item", "");
					if (tabsActiveHashBlock && index == tabsActiveHash[1]) tabsTitles[index].classList.add("_tab-active");
					tabsContentItem.hidden = !tabsTitles[index].classList.contains("_tab-active");
				});
		}
		function setTabsStatus(tabsBlock) {
			let tabsTitles = tabsBlock.querySelectorAll("[data-tabs-title]");
			let tabsContent = tabsBlock.querySelectorAll("[data-tabs-item]");
			const tabsBlockIndex = tabsBlock.dataset.tabsIndex;
			function isTabsAnamate(tabsBlock) {
				if (tabsBlock.hasAttribute("data-tabs-animate")) return tabsBlock.dataset.tabsAnimate > 0 ? Number(tabsBlock.dataset.tabsAnimate) : 500;
			}
			const tabsBlockAnimate = isTabsAnamate(tabsBlock);
			if (tabsContent.length > 0) {
				const isHash = tabsBlock.hasAttribute("data-tabs-hash");
				tabsContent = Array.from(tabsContent).filter((item) => item.closest("[data-tabs]") === tabsBlock);
				tabsTitles = Array.from(tabsTitles).filter((item) => item.closest("[data-tabs]") === tabsBlock);
				tabsContent.forEach((tabsContentItem, index) => {
					if (tabsTitles[index].classList.contains("_tab-active")) {
						if (tabsBlockAnimate) _slideDown(tabsContentItem, tabsBlockAnimate);
						else tabsContentItem.hidden = false;
						if (isHash && !tabsContentItem.closest(".popup")) setHash(`tab-${tabsBlockIndex}-${index}`);
					} else if (tabsBlockAnimate) _slideUp(tabsContentItem, tabsBlockAnimate);
					else tabsContentItem.hidden = true;
				});
			}
		}
		function setTabsAction(e) {
			const el = e.target;
			if (el.closest("[data-tabs-title]")) {
				const tabTitle = el.closest("[data-tabs-title]");
				const tabsBlock = tabTitle.closest("[data-tabs]");
				if (!tabTitle.classList.contains("_tab-active") && !tabsBlock.querySelector("._slide")) {
					let tabActiveTitle = tabsBlock.querySelectorAll("[data-tabs-title]._tab-active");
					tabActiveTitle.length ? (tabActiveTitle = Array.from(tabActiveTitle).filter((item) => item.closest("[data-tabs]") === tabsBlock)) : null;
					tabActiveTitle.length ? tabActiveTitle[0].classList.remove("_tab-active") : null;
					tabTitle.classList.add("_tab-active");
					setTabsStatus(tabsBlock);
				}
				e.preventDefault();
			}
		}
	}
	function functions_menuClose() {
		bodyUnlock();
		document.documentElement.classList.remove("menu-open");
	}
	function FLS(message) {
		setTimeout(() => {
			if (window.FLS) console.log(message);
		}, 0);
	}
	function uniqArray(array) {
		return array.filter(function (item, index, self) {
			return self.indexOf(item) === index;
		});
	}
	function dataMediaQueries(array, dataSetValue) {
		const media = Array.from(array).filter(function (item, index, self) {
			if (item.dataset[dataSetValue]) return item.dataset[dataSetValue].split(",")[0];
		});
		if (media.length) {
			const breakpointsArray = [];
			media.forEach((item) => {
				const params = item.dataset[dataSetValue];
				const breakpoint = {};
				const paramsArray = params.split(",");
				breakpoint.value = paramsArray[0];
				breakpoint.type = paramsArray[1] ? paramsArray[1].trim() : "max";
				breakpoint.item = item;
				breakpointsArray.push(breakpoint);
			});
			let mdQueries = breakpointsArray.map(function (item) {
				return "(" + item.type + "-width: " + item.value + "px)," + item.value + "," + item.type;
			});
			mdQueries = uniqArray(mdQueries);
			const mdQueriesArray = [];
			if (mdQueries.length) {
				mdQueries.forEach((breakpoint) => {
					const paramsArray = breakpoint.split(",");
					const mediaBreakpoint = paramsArray[1];
					const mediaType = paramsArray[2];
					const matchMedia = window.matchMedia(paramsArray[0]);
					const itemsArray = breakpointsArray.filter(function (item) {
						if (item.value === mediaBreakpoint && item.type === mediaType) return true;
					});
					mdQueriesArray.push({
						itemsArray,
						matchMedia,
					});
				});
				return mdQueriesArray;
			}
		}
	}
	class ScrollWatcher {
		constructor(props) {
			let defaultConfig = {
				logging: true,
			};
			this.config = Object.assign(defaultConfig, props);
			this.observer;
			!document.documentElement.classList.contains("watcher") ? this.scrollWatcherRun() : null;
		}
		scrollWatcherUpdate() {
			this.scrollWatcherRun();
		}
		scrollWatcherRun() {
			document.documentElement.classList.add("watcher");
			this.scrollWatcherConstructor(document.querySelectorAll("[data-watch]"));
		}
		scrollWatcherConstructor(items) {
			if (items.length) {
				this.scrollWatcherLogging(`Прокинувся, стежу за об'єктами (${items.length})...`);
				let uniqParams = uniqArray(
					Array.from(items).map(function (item) {
						return `${
							item.dataset.watchRoot ? item.dataset.watchRoot : null
						}|${item.dataset.watchMargin ? item.dataset.watchMargin : "0px"}|${item.dataset.watchThreshold ? item.dataset.watchThreshold : 0}`;
					})
				);
				uniqParams.forEach((uniqParam) => {
					let uniqParamArray = uniqParam.split("|");
					let paramsWatch = {
						root: uniqParamArray[0],
						margin: uniqParamArray[1],
						threshold: uniqParamArray[2],
					};
					let groupItems = Array.from(items).filter(function (item) {
						let watchRoot = item.dataset.watchRoot ? item.dataset.watchRoot : null;
						let watchMargin = item.dataset.watchMargin ? item.dataset.watchMargin : "0px";
						let watchThreshold = item.dataset.watchThreshold ? item.dataset.watchThreshold : 0;
						if (
							String(watchRoot) === paramsWatch.root &&
							String(watchMargin) === paramsWatch.margin &&
							String(watchThreshold) === paramsWatch.threshold
						)
							return item;
					});
					let configWatcher = this.getScrollWatcherConfig(paramsWatch);
					this.scrollWatcherInit(groupItems, configWatcher);
				});
			} else this.scrollWatcherLogging("Сплю, немає об'єктів для стеження. ZzzZZzz");
		}
		getScrollWatcherConfig(paramsWatch) {
			let configWatcher = {};
			if (document.querySelector(paramsWatch.root)) configWatcher.root = document.querySelector(paramsWatch.root);
			else if (paramsWatch.root !== "null") this.scrollWatcherLogging(`Эмм... батьківського об'єкта ${paramsWatch.root} немає на сторінці`);
			configWatcher.rootMargin = paramsWatch.margin;
			if (paramsWatch.margin.indexOf("px") < 0 && paramsWatch.margin.indexOf("%") < 0) {
				this.scrollWatcherLogging(`йой, налаштування data-watch-margin потрібно задавати в PX або %`);
				return;
			}
			if (paramsWatch.threshold === "prx") {
				paramsWatch.threshold = [];
				for (let i = 0; i <= 1; i += 0.005) paramsWatch.threshold.push(i);
			} else paramsWatch.threshold = paramsWatch.threshold.split(",");
			configWatcher.threshold = paramsWatch.threshold;
			return configWatcher;
		}
		scrollWatcherCreate(configWatcher) {
			this.observer = new IntersectionObserver((entries, observer) => {
				entries.forEach((entry) => {
					this.scrollWatcherCallback(entry, observer);
				});
			}, configWatcher);
		}
		scrollWatcherInit(items, configWatcher) {
			this.scrollWatcherCreate(configWatcher);
			items.forEach((item) => this.observer.observe(item));
		}
		scrollWatcherIntersecting(entry, targetElement) {
			if (entry.isIntersecting) {
				!targetElement.classList.contains("_watcher-view") ? targetElement.classList.add("_watcher-view") : null;
				this.scrollWatcherLogging(`Я бачу ${targetElement.classList}, додав клас _watcher-view`);
			} else {
				targetElement.classList.contains("_watcher-view") ? targetElement.classList.remove("_watcher-view") : null;
				this.scrollWatcherLogging(`Я не бачу ${targetElement.classList}, прибрав клас _watcher-view`);
			}
		}
		scrollWatcherOff(targetElement, observer) {
			observer.unobserve(targetElement);
			this.scrollWatcherLogging(`Я перестав стежити за ${targetElement.classList}`);
		}
		scrollWatcherLogging(message) {
			this.config.logging ? FLS(`[Спостерігач]: ${message}`) : null;
		}
		scrollWatcherCallback(entry, observer) {
			const targetElement = entry.target;
			this.scrollWatcherIntersecting(entry, targetElement);
			targetElement.hasAttribute("data-watch-once") && entry.isIntersecting ? this.scrollWatcherOff(targetElement, observer) : null;
			document.dispatchEvent(
				new CustomEvent("watcherCallback", {
					detail: {
						entry,
					},
				})
			);
		}
	}
	modules_flsModules.watcher = new ScrollWatcher({});
	let addWindowScrollEvent = false;
	function headerScroll() {
		const header = document.querySelector(".landing-page-hero__top");

		if (header) {
			addWindowScrollEvent = true;
			const headerBlock = document.querySelector("#shopify-section-header");
			console.log(headerBlock.offsetHeight);
			const headerShow = header.hasAttribute("data-scroll-show");
			const headerShowTimer = header.dataset.scrollShow ? header.dataset.scrollShow : 500;
			const startPoint = headerBlock.offsetHeight;
			let scrollDirection = 0;
			let timer;
			document.addEventListener("windowScroll", function (e) {
				const scrollTop = window.scrollY;
				clearTimeout(timer);
				if (scrollTop >= startPoint) {
					!header.classList.contains("_header-scroll") ? header.classList.add("_header-scroll") : null;
					if (headerShow) {
						if (scrollTop > scrollDirection) header.classList.contains("_header-show") ? header.classList.remove("_header-show") : null;
						else !header.classList.contains("_header-show") ? header.classList.add("_header-show") : null;
						timer = setTimeout(() => {
							!header.classList.contains("_header-show") ? header.classList.add("_header-show") : null;
						}, headerShowTimer);
					}
				} else {
					header.classList.contains("_header-scroll") ? header.classList.remove("_header-scroll") : null;
					if (headerShow) header.classList.contains("_header-show") ? header.classList.remove("_header-show") : null;
				}
				scrollDirection = scrollTop <= 0 ? 0 : scrollTop;
			});
		}
	}
	setTimeout(() => {
		if (addWindowScrollEvent) {
			let windowScroll = new Event("windowScroll");
			window.addEventListener("scroll", function (e) {
				document.dispatchEvent(windowScroll);
			});
		}
	}, 0);
	let gotoblock_gotoBlock = (targetBlock, noHeader = false, speed = 500, offsetTop = 0) => {
		const targetBlockElement = document.querySelector(targetBlock);
		if (targetBlockElement) {
			let headerItem = "";
			let headerItemHeight = 0;
			if (noHeader) {
				headerItem = "header.header";
				const headerElement = document.querySelector(headerItem);
				if (!headerElement.classList.contains("_header-scroll")) {
					headerElement.style.cssText = `transition-duration: 0s;`;
					headerElement.classList.add("_header-scroll");
					headerItemHeight = headerElement.offsetHeight;
					headerElement.classList.remove("_header-scroll");
					setTimeout(() => {
						headerElement.style.cssText = ``;
					}, 0);
				} else headerItemHeight = headerElement.offsetHeight;
			}
			let options = {
				speedAsDuration: true,
				speed,
				header: headerItem,
				offset: offsetTop,
				easing: "easeOutQuad",
			};
			document.documentElement.classList.contains("menu-open") ? functions_menuClose() : null;
			if (typeof SmoothScroll !== "undefined") new SmoothScroll().animateScroll(targetBlockElement, "", options);
			else {
				let targetBlockElementPosition = targetBlockElement.getBoundingClientRect().top + scrollY;
				targetBlockElementPosition = headerItemHeight ? targetBlockElementPosition - headerItemHeight : targetBlockElementPosition;
				targetBlockElementPosition = offsetTop ? targetBlockElementPosition - offsetTop : targetBlockElementPosition;
				window.scrollTo({
					top: targetBlockElementPosition,
					behavior: "smooth",
				});
			}
			FLS(`[gotoBlock]: Юхуу...їдемо до ${targetBlock}`);
		} else FLS(`[gotoBlock]: Йой... Такого блоку немає на сторінці: ${targetBlock}`);
	};
	function formFieldsInit(
		options = {
			viewPass: false,
			autoHeight: false,
		}
	) {
		document.body.addEventListener("focusin", function (e) {
			const targetElement = e.target;
			if (targetElement.tagName === "INPUT" || targetElement.tagName === "TEXTAREA") {
				if (!targetElement.hasAttribute("data-no-focus-classes")) {
					targetElement.classList.add("_form-focus");
					targetElement.parentElement.classList.add("_form-focus");
				}
				formValidate.removeError(targetElement);
				targetElement.hasAttribute("data-validate") ? formValidate.removeError(targetElement) : null;
			}
		});
		document.body.addEventListener("focusout", function (e) {
			const targetElement = e.target;
			if (targetElement.tagName === "INPUT" || targetElement.tagName === "TEXTAREA") {
				if (!targetElement.hasAttribute("data-no-focus-classes")) {
					targetElement.classList.remove("_form-focus");
					targetElement.parentElement.classList.remove("_form-focus");
				}
				targetElement.hasAttribute("data-validate") ? formValidate.validateInput(targetElement) : null;
			}
		});
		if (options.viewPass)
			document.addEventListener("click", function (e) {
				let targetElement = e.target;
				if (targetElement.closest('[class*="__viewpass"]')) {
					let inputType = targetElement.classList.contains("_viewpass-active") ? "password" : "text";
					targetElement.parentElement.querySelector("input").setAttribute("type", inputType);
					targetElement.classList.toggle("_viewpass-active");
				}
			});
		if (options.autoHeight) {
			const textareas = document.querySelectorAll("textarea[data-autoheight]");
			if (textareas.length) {
				textareas.forEach((textarea) => {
					const startHeight = textarea.hasAttribute("data-autoheight-min") ? Number(textarea.dataset.autoheightMin) : Number(textarea.offsetHeight);
					const maxHeight = textarea.hasAttribute("data-autoheight-max") ? Number(textarea.dataset.autoheightMax) : 1 / 0;
					setHeight(textarea, Math.min(startHeight, maxHeight));
					textarea.addEventListener("input", () => {
						if (textarea.scrollHeight > startHeight) {
							textarea.style.height = `auto`;
							setHeight(textarea, Math.min(Math.max(textarea.scrollHeight, startHeight), maxHeight));
						}
					});
				});
				function setHeight(textarea, height) {
					textarea.style.height = `${height}px`;
				}
			}
		}
	}
	let formValidate = {
		getErrors(form) {
			let error = 0;
			let formRequiredItems = form.querySelectorAll("*[data-required]");
			if (formRequiredItems.length)
				formRequiredItems.forEach((formRequiredItem) => {
					if ((formRequiredItem.offsetParent !== null || formRequiredItem.tagName === "SELECT") && !formRequiredItem.disabled)
						error += this.validateInput(formRequiredItem);
				});
			return error;
		},
		validateInput(formRequiredItem) {
			let error = 0;
			if (formRequiredItem.dataset.required === "email") {
				formRequiredItem.value = formRequiredItem.value.replace(" ", "");
				if (this.emailTest(formRequiredItem)) {
					this.addError(formRequiredItem);
					error++;
				} else this.removeError(formRequiredItem);
			} else if (formRequiredItem.type === "checkbox" && !formRequiredItem.checked) {
				this.addError(formRequiredItem);
				error++;
			} else if (!formRequiredItem.value.trim()) {
				this.addError(formRequiredItem);
				error++;
			} else this.removeError(formRequiredItem);
			return error;
		},
		addError(formRequiredItem) {
			formRequiredItem.classList.add("_form-error");
			formRequiredItem.parentElement.classList.add("_form-error");
			let inputError = formRequiredItem.parentElement.querySelector(".form__error");
			if (inputError) formRequiredItem.parentElement.removeChild(inputError);
			if (formRequiredItem.dataset.error)
				formRequiredItem.parentElement.insertAdjacentHTML("beforeend", `<div class="form__error">${formRequiredItem.dataset.error}</div>`);
		},
		removeError(formRequiredItem) {
			formRequiredItem.classList.remove("_form-error");
			formRequiredItem.parentElement.classList.remove("_form-error");
			if (formRequiredItem.parentElement.querySelector(".form__error"))
				formRequiredItem.parentElement.removeChild(formRequiredItem.parentElement.querySelector(".form__error"));
		},
		formClean(form) {
			form.reset();
			setTimeout(() => {
				let inputs = form.querySelectorAll("input,textarea");
				for (let index = 0; index < inputs.length; index++) {
					const el = inputs[index];
					el.parentElement.classList.remove("_form-focus");
					el.classList.remove("_form-focus");
					formValidate.removeError(el);
				}
				let checkboxes = form.querySelectorAll(".checkbox__input");
				if (checkboxes.length > 0)
					for (let index = 0; index < checkboxes.length; index++) {
						const checkbox = checkboxes[index];
						checkbox.checked = false;
					}
				if (modules_flsModules.select) {
					let selects = form.querySelectorAll(".select");
					if (selects.length)
						for (let index = 0; index < selects.length; index++) {
							const select = selects[index].querySelector("select");
							modules_flsModules.select.selectBuild(select);
						}
				}
			}, 0);
		},
		emailTest(formRequiredItem) {
			return !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(formRequiredItem.value);
		},
	};
	function formSubmit() {
		const forms = document.forms;
		if (forms.length)
			for (const form of forms) {
				form.addEventListener("submit", function (e) {
					const form = e.target;
					formSubmitAction(form, e);
				});
				form.addEventListener("reset", function (e) {
					const form = e.target;
					formValidate.formClean(form);
				});
			}
		async function formSubmitAction(form, e) {
			const error = !form.hasAttribute("data-no-validate") ? formValidate.getErrors(form) : 0;
			if (error === 0) {
				const ajax = form.hasAttribute("data-ajax");
				if (ajax) {
					e.preventDefault();
					const formAction = form.getAttribute("action") ? form.getAttribute("action").trim() : "#";
					const formMethod = form.getAttribute("method") ? form.getAttribute("method").trim() : "GET";
					const formData = new FormData(form);
					form.classList.add("_sending");
					const response = await fetch(formAction, {
						method: formMethod,
						body: formData,
					});
					if (response.ok) {
						let responseResult = await response.json();
						form.classList.remove("_sending");
						formSent(form, responseResult);
					} else {
						alert("Помилка");
						form.classList.remove("_sending");
					}
				} else if (form.hasAttribute("data-dev")) {
					e.preventDefault();
					formSent(form);
				}
			} else {
				e.preventDefault();
				if (form.querySelector("._form-error") && form.hasAttribute("data-goto-error")) {
					const formGoToErrorClass = form.dataset.gotoError ? form.dataset.gotoError : "._form-error";
					gotoblock_gotoBlock(formGoToErrorClass, true, 1e3);
				}
			}
		}
		function formSent(form, responseResult = ``) {
			document.dispatchEvent(
				new CustomEvent("formSent", {
					detail: {
						form,
					},
				})
			);
			setTimeout(() => {
				if (modules_flsModules.popup) {
					const popup = form.dataset.popupMessage;
					popup ? modules_flsModules.popup.open(popup) : null;
				}
			}, 0);
			formValidate.formClean(form);
			formLogging(`Форму відправлено!`);
		}
		function formLogging(message) {
			FLS(`[Форми]: ${message}`);
		}
	}

	class DynamicAdapt {
		constructor(type) {
			this.type = type;
		}
		init() {
			this.оbjects = [];
			this.daClassname = "_dynamic_adapt_";
			this.nodes = [...document.querySelectorAll("[data-da]")];
			this.nodes.forEach((node) => {
				const data = node.dataset.da.trim();
				const dataArray = data.split(",");
				const оbject = {};
				оbject.element = node;
				оbject.parent = node.parentNode;
				оbject.destination = document.querySelector(`${dataArray[0].trim()}`);
				оbject.breakpoint = dataArray[1] ? dataArray[1].trim() : "767";
				оbject.place = dataArray[2] ? dataArray[2].trim() : "last";
				оbject.index = this.indexInParent(оbject.parent, оbject.element);
				this.оbjects.push(оbject);
			});
			this.arraySort(this.оbjects);
			this.mediaQueries = this.оbjects
				.map(({ breakpoint }) => `(${this.type}-width: ${breakpoint}px),${breakpoint}`)
				.filter((item, index, self) => self.indexOf(item) === index);
			this.mediaQueries.forEach((media) => {
				const mediaSplit = media.split(",");
				const matchMedia = window.matchMedia(mediaSplit[0]);
				const mediaBreakpoint = mediaSplit[1];
				const оbjectsFilter = this.оbjects.filter(({ breakpoint }) => breakpoint === mediaBreakpoint);
				matchMedia.addEventListener("change", () => {
					this.mediaHandler(matchMedia, оbjectsFilter);
				});
				this.mediaHandler(matchMedia, оbjectsFilter);
			});
		}
		mediaHandler(matchMedia, оbjects) {
			if (matchMedia.matches)
				оbjects.forEach((оbject) => {
					this.moveTo(оbject.place, оbject.element, оbject.destination);
				});
			else
				оbjects.forEach(({ parent, element, index }) => {
					if (element.classList.contains(this.daClassname)) this.moveBack(parent, element, index);
				});
		}
		moveTo(place, element, destination) {
			element.classList.add(this.daClassname);
			if (place === "last" || place >= destination.children.length) {
				destination.append(element);
				return;
			}
			if (place === "first") {
				destination.prepend(element);
				return;
			}
			destination.children[place].before(element);
		}
		moveBack(parent, element, index) {
			element.classList.remove(this.daClassname);
			if (parent.children[index] !== void 0) parent.children[index].before(element);
			else parent.append(element);
		}
		indexInParent(parent, element) {
			return [...parent.children].indexOf(element);
		}
		arraySort(arr) {
			if (this.type === "min")
				arr.sort((a, b) => {
					if (a.breakpoint === b.breakpoint) {
						if (a.place === b.place) return 0;
						if (a.place === "first" || b.place === "last") return -1;
						if (a.place === "last" || b.place === "first") return 1;
						return 0;
					}
					return a.breakpoint - b.breakpoint;
				});
			else {
				arr.sort((a, b) => {
					if (a.breakpoint === b.breakpoint) {
						if (a.place === b.place) return 0;
						if (a.place === "first" || b.place === "last") return 1;
						if (a.place === "last" || b.place === "first") return -1;
						return 0;
					}
					return b.breakpoint - a.breakpoint;
				});
				return;
			}
		}
	}
	const da = new DynamicAdapt("max");
	da.init();
    function showMore() {
		const showMoreBlocks = document.querySelectorAll('[data-showmore]');
		let showMoreBlocksRegular;
		let mdQueriesArray;
		if (showMoreBlocks.length) {
			// Отримання звичайних об'єктів
			showMoreBlocksRegular = Array.from(showMoreBlocks).filter(function (item, index, self) {
				return !item.dataset.showmoreMedia;
			});
			// Ініціалізація звичайних об'єктів
			showMoreBlocksRegular.length ? initItems(showMoreBlocksRegular) : null;

			document.addEventListener("click", showMoreActions);
			window.addEventListener("resize", showMoreActions);

			// Отримання об'єктів з медіа-запитами
			mdQueriesArray = dataMediaQueries(showMoreBlocks, "showmoreMedia");
			if (mdQueriesArray && mdQueriesArray.length) {
				mdQueriesArray.forEach(mdQueriesItem => {
					// Подія
					mdQueriesItem.matchMedia.addEventListener("change", function () {
						initItems(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
					});
				});
				initItemsMedia(mdQueriesArray);
			}
		}
		function initItemsMedia(mdQueriesArray) {
			mdQueriesArray.forEach(mdQueriesItem => {
				initItems(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
			});
		}
		function initItems(showMoreBlocks, matchMedia) {
			showMoreBlocks.forEach(showMoreBlock => {
				initItem(showMoreBlock, matchMedia);
			});
		}
		function initItem(showMoreBlock, matchMedia = false) {
			showMoreBlock = matchMedia ? showMoreBlock.item : showMoreBlock;
			let showMoreContent = showMoreBlock.querySelectorAll('[data-showmore-content]');
			let showMoreButton = showMoreBlock.querySelectorAll('[data-showmore-button]');
			showMoreContent = Array.from(showMoreContent).filter(item => item.closest('[data-showmore]') === showMoreBlock)[0];
			showMoreButton = Array.from(showMoreButton).filter(item => item.closest('[data-showmore]') === showMoreBlock)[0];
			const hiddenHeight = getHeight(showMoreBlock, showMoreContent);
			if (matchMedia.matches || !matchMedia) {
				if (hiddenHeight < getOriginalHeight(showMoreContent)) {
					_slideUp(showMoreContent, 0, showMoreBlock.classList.contains('_showmore-active') ? getOriginalHeight(showMoreContent) : hiddenHeight);
					showMoreButton.hidden = false;
				} else {
					_slideDown(showMoreContent, 0, hiddenHeight);
					showMoreButton.hidden = true;
				}
			} else {
				_slideDown(showMoreContent, 0, hiddenHeight);
				showMoreButton.hidden = true;
			}
		}
		function getHeight(showMoreBlock, showMoreContent) {
			let hiddenHeight = 0;
			const showMoreType = showMoreBlock.dataset.showmore ? showMoreBlock.dataset.showmore : 'size';
			const rowGap = parseFloat(getComputedStyle(showMoreContent).rowGap) ? parseFloat(getComputedStyle(showMoreContent).rowGap) : 0;
			if (showMoreType === 'items') {
				const showMoreTypeValue = showMoreContent.dataset.showmoreContent ? showMoreContent.dataset.showmoreContent : 3;
				const showMoreItems = showMoreContent.children;
				for (let index = 1; index < showMoreItems.length; index++) {
					const showMoreItem = showMoreItems[index - 1];
					const marginTop = parseFloat(getComputedStyle(showMoreItem).marginTop) ? parseFloat(getComputedStyle(showMoreItem).marginTop) : 0;
					const marginBottom = parseFloat(getComputedStyle(showMoreItem).marginBottom) ? parseFloat(getComputedStyle(showMoreItem).marginBottom) : 0;
					hiddenHeight += showMoreItem.offsetHeight + marginTop;
					if (index == showMoreTypeValue) break;
					hiddenHeight += marginBottom;
				}
				rowGap ? hiddenHeight += (showMoreTypeValue - 1) * rowGap : null;
			} else {
				const showMoreTypeValue = showMoreContent.dataset.showmoreContent ? showMoreContent.dataset.showmoreContent : 150;
				hiddenHeight = showMoreTypeValue;
			}
			return hiddenHeight;
		}

		function getOriginalHeight(showMoreContent) {
			let parentHidden;
			let hiddenHeight = showMoreContent.offsetHeight;
			showMoreContent.style.removeProperty('height');
			if (showMoreContent.closest(`[hidden]`)) {
				parentHidden = showMoreContent.closest(`[hidden]`);
				parentHidden.hidden = false;
			}
			let originalHeight = showMoreContent.offsetHeight;
			parentHidden ? parentHidden.hidden = true : null;
			showMoreContent.style.height = `${hiddenHeight}px`;
			return originalHeight;
		}
		function showMoreActions(e) {
			const targetEvent = e.target;
			const targetType = e.type;
			if (targetType === 'click') {
				if (targetEvent.closest('[data-showmore-button]')) {
					const showMoreButton = targetEvent.closest('[data-showmore-button]');
					const showMoreBlock = showMoreButton.closest('[data-showmore]');
					const showMoreContent = showMoreBlock.querySelector('[data-showmore-content]');
					const showMoreSpeed = showMoreBlock.dataset.showmoreButton ? showMoreBlock.dataset.showmoreButton : '500';
					const hiddenHeight = getHeight(showMoreBlock, showMoreContent);
					if (!showMoreContent.classList.contains('_slide')) {
						showMoreBlock.classList.contains('_showmore-active') ? _slideUp(showMoreContent, showMoreSpeed, hiddenHeight) : _slideDown(showMoreContent, showMoreSpeed, hiddenHeight);
						showMoreBlock.classList.toggle('_showmore-active');
					}
				}
			} else if (targetType === 'resize') {
				showMoreBlocksRegular && showMoreBlocksRegular.length ? initItems(showMoreBlocksRegular) : null;
				mdQueriesArray && mdQueriesArray.length ? initItemsMedia(mdQueriesArray) : null;
			}
		}

}
	window["FLS"] = true;
	isWebp();
  showMore();
	tabs();
	// formFieldsInit({
	// 	viewPass: false,
	// 	autoHeight: false,
	// });
	// formSubmit();
	// headerScroll();
})();
